<div *ngIf="displayMeasurementTool && measurementTools.length > 0" class="mb-3">
    <div class="table-header fw-bold py-2 d-flex flex-row flex-nowrap">
        <div class="col px-2" translate="CONFIRMATION_MEASUREMENT_TOOLS_CALLIBRATION_DATE_ID"></div>
        <div
            class="d-none d-lg-block col px-2"
            translate="CONFIRMATION_MEASUREMENT_TOOLS_CALLIBRATION_DATE_DESCRIPTION"
        ></div>
        <div class="col px-2" translate="CONFIRMATION_MEASUREMENT_TOOLS_CALLIBRATION_DATE"></div>
    </div>
    <div *ngFor="let measurementTool of measurementTools" class="table-row py-2">
        <div class="d-flex flex-row">
            <div class="col px-2">{{ measurementTool.measurementToolId.value }}</div>
            <div class="d-none d-lg-block col px-2">{{ measurementTool.calibration.toolDescription }}</div>
            <div class="col px-2">{{ measurementTool.calibration.calibrationDate }}</div>
        </div>
        <div class="d-block d-lg-none col-12 my-1">
            <div
                class="col-4 px-2 col-form-label"
                translate="CONFIRMATION_MEASUREMENT_TOOLS_CALLIBRATION_DATE_DESCRIPTION"
            ></div>
            <div class="col-8 px-2">
                <span class="form-control-plaintext">{{ measurementTool.calibration.toolDescription }}</span>
            </div>
        </div>
    </div>
</div>

<div *ngIf="displayMeasurementToolDetails" class="mb-3">
    <div class="table-header fw-bold py-2 d-flex flex-row flex-nowrap">
        <div class="col px-2" translate="CONFIRMATION_MEASUREMENT_TOOLS_DESCRIPTION"></div>
        <div class="col px-2" translate="CONFIRMATION_MEASUREMENT_TOOLS_TID"></div>
    </div>
    <div *ngIf="measurementToolsEmptyMessage; else showMeasurementTools" class="table-row py-2">
        <div class="d-flex flex-row">
            <label class="col px-2">{{ measurementToolsEmptyMessage }}</label>
        </div>
    </div>
    <ng-template #showMeasurementTools>
        <div *ngFor="let measurementTool of measurementToolsDetailsList" class="table-row py-2">
            <div class="d-flex flex-row">
                <div class="col px-2">{{ measurementTool.equipmentDescription.value }}</div>
                <div class="col px-2">{{ measurementTool.technicalId.value }}</div>
            </div>
        </div>
    </ng-template>
</div>

<div *ngIf="isRadioActiveToolsUsed">
    <hr />
    <div class="row">
        <label
            class="col-12 col-lg-2 col-form-label text-start text-lg-end"
            for="RadioActiveToolId"
            translate="CONFIRMATION_SUMMARY_RADIO_ACTIVE_TOOL_MESSAGE"
        ></label>
        <div class="col-12 col-lg-8" id="RadioActiveToolId">
            <span
                class="form-control-plaintext px-0"
                translate="CONFIRMATION_MEASUREMENT_TOOLS_RADIO_ACTIVE_ASSESSMENT_COMPLETE"
            >
            </span>
        </div>
    </div>
</div>
